<template>
<div class="grid mt-4" >	


<div class="col-12 ">
<span class="p-float-label">
<InputText  type="text" v-model="searchterm" class="w-full p-inputtext-sm"   @input="searchInterval" :disabled="searching"/>
<label :for="$store.state.calculations.selectednode.id" class="text-primary">Firma ismi ya da kodu</label>
</span>
</div>

<div class="col-12 " v-if="searchterm && !searching">

	<template v-if="!searchresults.length">
	<h4 class="text-primary text-center">Sonuç Bulunamadı</h4>
	</template>
	<template v-else>
	<div class="grid my-1" v-for="item in searchresults">
	<div class="col-1"><Checkbox  :value="item.id" v-model="selecteditems" /></div>
	<div class="col-8"><p class="text-primary my-0">{{item.name}}</p></div>
	<div class="col-3"><p class="text-primary my-0">{{item.suppliercode}}</p></div>
	</div>	
	<div class="grid">
	<div class="col-12 flex  justify-content-end">

	<Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-2 ml-2"   @click="cancelSelection" label="İptal" />
	<Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2 ml-2"   @click="addSelection" label="Ekle" />

	</div>
	</div>
	</template>

</div>

<template  v-if="selected_suppliers.length">
<div class="col-12"><h3 class="text-primary mb-3 mt-3 font-medium">Ekli Tedarikçiler</h3></div>
<div class="col-12"><hr></div>
<div class="col-12" v-for="supplier in suppliers">
<div class="grid">
<div class="col-8"><p class="text-primary my-0">{{supplier.name}}</p></div>
<div class="col-3"><p class="text-primary my-0">{{supplier.suppliercode}}</p></div>
<div class="col-1">
<Button type="button" class="p-button-danger p-button-outlined p-button-sm mt-0"  icon="pi pi-trash" @click="deleteSupplier(supplier.id)" />
</div>
</div>
</div>

</template>


<div class="col-12" v-else>
<h4 class="text-primary text-center">Ekli tedarikçi yok</h4>
</div>

</div>
</template>

<script>
export default {

  name: 'ExemptSuppliersNodeData',

  data () {
    return {
    	searchterm:null,
    	searchresults:[],
    	intervalobj:null,
    	searching:false,
    	selecteditems:[],
    	loadingsuppliers:false,
    	suppliers:[],
    }
  },
  computed:{
  	selected_suppliers()
  	{
  		if(this.$store.state.calculations.selectednode.data.selected_suppliers)
	      {
	        this.loadSelectedSuppliers()
	        return this.$store.state.calculations.selectednode.data.selected_suppliers
	      }
  	}
  },
  methods:{
  	deleteSupplier(id)
  	{
  		this.$store.state.calculations.selectednode.data.selected_suppliers = this.$store.state.calculations.selectednode.data.selected_suppliers.filter(item=>item !==id)
  		let nodes = this.$store.state.calculations.nodes
		let selectednode_ind = nodes.findIndex((item)=>{return item.id == this.$store.state.calculations.selectednode.id})
		nodes[selectednode_ind] = this.$store.state.calculations.selectednode
		this.$store.dispatch('calculations/setNodes',nodes)
		this.suppliers = this.suppliers.filter(item=>item.id !==id)
  	},
  	cancelSelection()
  	{
  		this.searchterm = null
  		this.searchresults = []
  		this.selecteditems = []
  	},
  	async addSelection()
  	{
  		console.log(this.selecteditems)
  		console.log(this.$store.state.calculations.selectednode.data.selected_suppliers)
  		for(let selecteditem of this.selecteditems)
  		{
  			
  			let ind = this.$store.state.calculations.selectednode.data.selected_suppliers.findIndex(item=>item == selecteditem)
  			if(ind==-1)
  			{
  				this.$store.state.calculations.selectednode.data.selected_suppliers.push(selecteditem)
  			}
  		}
		let nodes = this.$store.state.calculations.nodes
		let selectednode_ind = nodes.findIndex((item)=>{return item.id == this.$store.state.calculations.selectednode.id})
		nodes[selectednode_ind] = this.$store.state.calculations.selectednode
		await this.$store.dispatch('calculations/setNodes',nodes)
  		await this.loadSelectedSuppliers()
  		await this.cancelSelection()
  		
  	},
  	searchInterval()
  	{
  		clearInterval(this.intervalobj);
        this.intervalobj = setInterval(()=>{
            this.search()
            clearInterval(this.intervalobj);
        },1000)
  	},
  	async loadSelectedSuppliers()
  	{
  		console.log("loadSelectedSuppliers")
  		this.suppliers = []
  		this.loadingsuppliers = true
  		let suppliers = this.$store.state.calculations.selectednode.data.selected_suppliers
  		console.log(suppliers)
  		for(let supplier of suppliers)
  		{
  			let item = await this.generalApiGetWithoutLoader("supplier/show_simple/"+supplier)
  			this.suppliers.push(item)
  		}

  		this.loadingsuppliers = true
  	},
  	async search()
  	{
  		this.searching = true
  		let searchterm = await this.searchterm.toUpperCase();
  		let searchresults = await this.generalApiGetWithoutLoader("brand/suppliers/"+this.$route.params.id+"/"+0+"/"+100+"?search="+searchterm)
  		this.searchresults = searchresults.data
  		console.log(this.searchresults)
  		this.searching = false
  	}
  },
}
</script>

<style lang="css" scoped>
</style>